import React, { useState, useEffect } from 'react';
import { PartnerHomeCalculatorTab } from "./PartnerHomeCalculatorTab";
import { PartnerSMECalculatorTab } from "./PartnerSMECalculatorTab";
import './partnerCalc.css';

export function PartnerCalculator(props) {
    const [calTab, setCalTab] = useState('stay');

    function smeTabClick(tab){
        console.log("smeTabClick: " + tab);

        if(tab === 'stay'){
            setCalTab('stay');
        }
    }

    function homeTabClick(tab){
        console.log("homeTabClick: " + tab);

        if(tab === 'business'){
            setCalTab('business');
        }
    }

    return (
        <section id="calculators">
            <div className={'cal-tab-stay ' + (calTab === 'stay' ? '' : 'hide')}>
                <PartnerHomeCalculatorTab {...props.calcDetail} openErrorPopup={props.openErrorPopup} onTabClick={homeTabClick} propertyId={props.PropertyID}/>
            </div>
            <div className={'cal-tab-business ' + (calTab === 'business' ? '' : 'hide')}>
                <PartnerSMECalculatorTab {...props.calcDetail} openErrorPopup={props.openErrorPopup} onTabClick={smeTabClick} propertyId={props.PropertyID}/>
            </div>
        </section>
      );
}